module.exports = __webpack_public_path__ + "img/logo.b65a915d.png";